export default {
    sms: 'SMS Service',
    sms_management: 'SMS Management',
    create_sms: 'Create SMS',
    create_new_sms: 'New SMS',
    schedule: 'Schedule',
    brand_names: 'Brandnames',
    manual: 'User Manual',
    web_tool: 'Web tool',
    sms_brand_name: 'SMS Brandname',
    new_brand_name: 'New Brandname',
    create_template: 'Create Template',
    update_template: 'Update Template',
    sms_info: {
        1: "With 1Byte's SMS Brandname Service you can deliver customer service and advertising messages at ease.",
        2: 'Brandname: what will be display as the subject of the SMS message, it should not be longer than 11 characters and has the same name as your business',
    },
    brand_name: 'Brandname',
    company_name: '(Company name)',
    reg_date: 'Reg Date',
    description: 'Description',
    brand_name_list: 'Brandname List',
    update_brand_name: 'Update Brandname',
    modal_register_title: 'Register using SMS Brandname',
    modal_register_title_confirm: 'Confirm SMS Brandname',
    upload_file: 'Upload File',
    attach_file: 'Attach File',
    full_name: 'Full name',
    phone_number: 'Phone number',
    date_of_birth: 'Date of birth',
    birthday: 'Birthday',
    group_name: 'Group Name',
    accept_type:
        'Please compress and upload your business certificate registration under .zip or .rar format',
    register_brand_name: 'Register Brandname',
    number_of_sms: 'Number of SMS',
    unit: 'Unit',
    khmer: 'Khmer',
    vietnam: 'Vietnam',
    vietnamese: 'Vietnamese',
    chinese: 'Chinese',
    english: 'English',
    arabic: 'Arabic',
    character: 'Character',
    note: 'Note',
    sms_rule_title: {
        ae: 'MESSAGE LENGTH IN ARABIC, ENGLISH AND CHINESE',
        kh: 'MESSAGE LENGTH IN KHMER, ENGLISH, VIETNAMESE AND CHINESE',
        th: 'MESSAGE LENGTH IN THAI, ENGLISH, VIETNAMESE AND CHINESE',
    },
    sms_rules_note: {
        1: 'Message content: no sexual harassment, politics or religions, advertisement of 1Byte’s competitors.',
        2: 'Checkpoint: The system automatically checks the content before sending Customer care messages. For advertising messages, the system needs AM to approve content of message, exclude sending SMS to white list subscribers and denying services through short number.',
        3: 'Post-inspection: if the message is incorrect with type classification and message regulation, Product Dept will notify and suspend service (according to specific cases). Product Dept. update whitelist upon request of Customer through internal channels.',
    },
    existing_template: 'Existing Template',
    category: 'Category',
    subject: 'Subject',
    content: 'Content',
    confirm_delete_text: 'Are you sure you want to delete SMS Template?',
    confirm_delete_title: 'Confirm',
    modal_create_template_title: 'Create New Template',
    modal_edit_template_title: 'Edit Template',
    characters_left: 'Remaining characters till the next SMS count',
    number_sms: 'Number of SMS',
    modal_import_csv_title: {
        step_1: 'Import List From CSV File',
        step_2: 'Import List From CSV File',
        step_3_checking: 'Checking data',
        step_3: 'Please Check Again',
        step_4: 'Customer List',
    },
    create_sms_form: {
        label: 'Send SMS ',
        brand_name: 'Brandname',
        subject_label: 'Subject',
        content_label: 'Content',
        sender_brandname_placeholder: 'Select Brandname',
    },
    create_sms_step2: {
        receiver_label: 'Receiver',
        schedule_label: 'Schedule',
        customer_group_label: 'Group',
        customer_group_import_label: 'Import List from CSV',
        customer_group_download_label: 'Download Template',
        customer_group_hint: {
            part1: 'CSV File has three columns by default:',
            part2: 'FullName, Phone Number must start with 0 or +855',
            read_more_rule: 'read more phone rule.',
            part3: 'and Date Of Birth (DD/MM/YYYY).',
        },
        phone_rule_modal: {
            title: 'Table of mobile phone prefix number in Cambodia',
            note: 'Note: Prefix with asterisk (*) is 7 digits number',
            button_text: 'OK',
        },
        customers: {
            title: 'Customers',
        },
    },
    modal_import_csv_content: {
        step_1: {
            title: 'Step 1 of 2: Upload File',
            hint: 'CSV File have three column by default FullName, Phone Number and Date Of Birth',
        },
        step_2: {
            title: 'Step 2 of 2: Map fields in CSV with column in Customer table',
        },
        step_3: {
            invalid:
                'Invalid or empty phone number in CSV File. Please check #C4, #A6 the file again',
            duplicate: {
                text_1: 'Phone number (s)',
                text_2: 'has been duplicated! Are you want to remove?',
            },
        },
    },
    select_column_placeholder: 'Select a field form CSV data',
    customer_error: 'Imported data is invalid, please check below records:',
    duplicate_phone_message: {
        1: 'Phone number (s)',
        2: 'has been duplicated! Are you want to remove?',
    },
    receiver_details: 'Receiver Details',
    schedule_detail: 'Schedule Detail',
    sms_type: 'SMS Type',
    receiver: 'Receiver',
    id: 'ID',
    total_of_sms: 'Total Of SMS',
    total_sent: 'Total Sent',
    created_date: 'Created Date',
    date: 'Date',
    status: 'Status',
    action: 'Action',
    search_place_holder: 'ID, subject, content, brandname',
    status_sms: 'Status SMS',
    sms_amount_from: 'Total of SMS From',
    sms_detail: 'SMS Detail',
    details: 'Details',
    total_price: 'Total Prices',
    export_report: 'Export Report',
    total_sent_detail: 'Total Sent Detail',
    form_schedule: {
        send_before: 'Send before',
        days: 'day(s)',
        at: 'At',
    },
    customer_list: 'Customer list',
    empty_birthday_error:
        'Date Of Birth is empty. Please check the file again!',
    empty_birthday_error_warning:
        'Customer list is still missing the date of birth, do you want to close the popup?',
    amount_sms_from_to:
        'The starting total of SMS must be less than the ending',
    birthday_message: 'Birthday message',
    now: 'Now',
    no_event_display: 'No events to display',
    type: 'type',
    brand_name_types: {
        international: 'International',
        cambodia: 'Cambodia',
    },
    send_results: 'Send results',
    pending: 'Pending',
    summary: 'Summary',
    go_to_this_transaction: 'Go to this transaction',
    confirm_cancel_text: {
        sms: 'Are you sure you want to cancel this SMS transaction?',
        schedule: 'Are you sure you want to cancel this SMS schedule?',
    },
    list_sms_failures: 'SMS failures list',
    sms_service_trial: 'SMS Service Trial',
    sms_service_trial_content_title: 'Content will be sent',
    try_demo_note:
        'Phone number must start with 0 or +855, you can read more about phone rules {here}',
};
